var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWallet = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21.999 12v5a4.724 4.724 0 0 1-5 5h-10a4.724 4.724 0 0 1-5-5v-5a4.654 4.654 0 0 1 4.19-4.94Q6.59 7 6.999 7h10q.376-.005.75.05a4.664 4.664 0 0 1 4.25 4.95"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.751 7.05a4.6 4.6 0 0 0-.75-.05h-10q-.406 0-.81.06c.15-.29.347-.553.58-.78l3.25-3.26a3.525 3.525 0 0 1 4.96 0l1.75 1.77c.615.597.98 1.404 1.02 2.26M22 12.5h-3a2 2 0 0 0 0 4h3"
})));
export { SvgWallet as ReactComponent };
export default __webpack_public_path__ + "335a3cd968dc7a4f93a6060ff8163247.svg";